var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonUserAvatarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1826_5514)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5334 46.8596C53.4077 43.4042 55.4068 39.3079 56.3616 34.9173C57.3164 30.5266 57.1987 25.9708 56.0187 21.6352C54.8386 17.2995 52.6308 13.3117 49.582 10.0089C46.5332 6.70616 42.7332 4.18568 38.5033 2.66071C34.2735 1.13573 29.7382 0.651109 25.2813 1.24785C20.8243 1.84458 16.5768 3.50512 12.8979 6.08898C9.2191 8.67285 6.21722 12.104 4.14623 16.0923C2.07524 20.0805 0.996072 24.5084 1.00001 29.0015C1.00152 35.5332 3.30515 41.8557 7.50666 46.8596L7.46663 46.8936C7.60673 47.0616 7.76684 47.2056 7.91095 47.3716C8.09108 47.5776 8.28521 47.7715 8.47135 47.9715C9.03175 48.5795 9.60816 49.1634 10.2126 49.7113C10.3967 49.8793 10.5869 50.0353 10.773 50.1953C11.4134 50.7472 12.0719 51.2712 12.7544 51.7591C12.8425 51.8191 12.9225 51.8971 13.0106 51.9591V51.9351C17.6981 55.2311 23.2901 57 29.022 57C34.7539 57 40.3459 55.2311 45.0335 51.9351V51.9591C45.1215 51.8971 45.1996 51.8191 45.2896 51.7591C45.9701 51.2692 46.6306 50.7472 47.2711 50.1953C47.4572 50.0353 47.6473 49.8773 47.8315 49.7113C48.4359 49.1614 49.0123 48.5795 49.5727 47.9715C49.7588 47.7715 49.951 47.5776 50.1331 47.3716C50.2752 47.2056 50.4373 47.0616 50.5774 46.8916L50.5334 46.8596ZM29.02 13.0032C30.8013 13.0032 32.5426 13.531 34.0237 14.5198C35.5048 15.5087 36.6592 16.9141 37.3409 18.5585C38.0226 20.2029 38.2009 22.0123 37.8534 23.7579C37.5059 25.5036 36.6481 27.107 35.3885 28.3656C34.129 29.6241 32.5242 30.4812 30.7771 30.8284C29.03 31.1756 27.2191 30.9974 25.5734 30.3163C23.9277 29.6352 22.5211 28.4818 21.5314 27.0019C20.5418 25.522 20.0136 23.7821 20.0136 22.0023C20.0136 19.6156 20.9625 17.3266 22.6515 15.639C24.3405 13.9513 26.6314 13.0032 29.02 13.0032ZM13.0226 46.8596C13.0573 44.2339 14.1253 41.7273 15.9954 39.8823C17.8656 38.0372 20.3876 37.002 23.0157 37.0007H35.0243C37.6525 37.002 40.1745 38.0372 42.0446 39.8823C43.9148 41.7273 44.9827 44.2339 45.0174 46.8596C40.628 50.8119 34.9288 52.9991 29.02 52.9991C23.1113 52.9991 17.412 50.8119 13.0226 46.8596Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8539 28.6468L47.7074 28.5H47.5H47.2407C48.035 27.3637 48.5 25.9829 48.5 24.5C48.5 20.6339 45.3661 17.5 41.5 17.5C37.6339 17.5 34.5 20.6339 34.5 24.5C34.5 28.3661 37.6339 31.5 41.5 31.5C42.9829 31.5 44.3637 31.035 45.5 30.2407V30.5V30.7074L45.6468 30.8539L50.6468 35.8439L51.0004 36.1968L51.3536 35.8436L52.8436 34.3536L53.1968 34.0004L52.8439 33.6468L47.8539 28.6468ZM41.5 28.5C39.2861 28.5 37.5 26.7139 37.5 24.5C37.5 22.2861 39.2861 20.5 41.5 20.5C43.7139 20.5 45.5 22.2861 45.5 24.5C45.5 26.7139 43.7139 28.5 41.5 28.5Z",
    fill: "#CBCBCB",
    stroke: "#EEEEEE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 57,
    rx: 28.5,
    stroke: "#E2E2E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1826_5514"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonUserAvatarFilled);
export default __webpack_public_path__ + "static/media/carbon_user-avatar-filled.d1b0b7e8e76a6e33849b0ee59aa5afdd.svg";
export { ForwardRef as ReactComponent };